const { start } = require("@popperjs/core");

class TableBuilder {
    constructor(opts) {
        this.id = opts.customId ? opts.customId : Math.floor(Math.random() * 999999);
        this.table = opts.table;
        this.tableBody = opts.tableBody;
        this.tableRowRenderer = opts.tableRowRenderer;
        this.rowsPerPage = opts.rowsPerPage;
        this.currentPage = 1;
        this.fullData = opts.data ? opts.data : [];
        this.seenData = opts.data ? opts.data : [];
        this.maxRecords = opts.maxPages ? opts.maxPages : [];
        this.fetchTableData = opts.fetchTableData ? opts.fetchTableData : false;
        this.filter = opts.filter;
        this.OnClickFirstPage = opts.OnClickFirstPage ? opts.OnClickFirstPage : false;
        this.OnClickLastPage = opts.OnClickLastPage ? opts.OnClickLastPage : false;
        this.OnTableRendered = opts.OnTableRendered ? opts.OnTableRendered : false;
        this.rowRendererOpts = false;
        this.footerWithId = opts.footerWithId ? opts.footerWithId : true;

        try {
            //console.log('TableBuilder', this);
            this.renderPage();
            //this.bindPageChange();
        } catch {
            //try again script
            setTimeout(() => {
                this.renderPage();
            }, 1000);
        }
        this.bindFirstLastPage();
        return this;
    }

    renderPage(page = false, newFilters = false, newData = false, newRowsPerPage = false, newMaxPages = false, rowRendererOpts = false) {
        //console.log('[TableBuild] rendering page', page, newFilters, newData, newRowsPerPage, newMaxPages);
        if (newFilters) {
            this.filter = newFilters;
            this.currentPage = 1;
        }
        if (newRowsPerPage) {
            this.rowsPerPage = newRowsPerPage;
            this.currentPage = 1;
        }
        if (newMaxPages !== false) {
            this.maxRecords = newMaxPages;
            //this.currentPage = 1;
        }
        if (rowRendererOpts) {
            this.rowRendererOpts = rowRendererOpts;
        }
        if (newData) {
            this.fullData = newData;

            //let falsecurrentPage = page ? page : this.currentPage;
            //let falsetrimStart = (falsecurrentPage - 1) * this.rowsPerPage;
            //let falsetrimEnd = falsetrimStart + this.rowsPerPage;
            //let falsefullData = this.fullData;
            //let falsefilteredData = this.applyFilters(falsefullData);
            //let falsetrimmedData = falsefilteredData.slice(falsetrimStart, falsetrimEnd);
            let falsemaxPages = Math.ceil(this.maxRecords / this.rowsPerPage);

            if (this.currentPage > falsemaxPages) {
                this.currentPage--;
            }
        }
        //console.log(' this.fullData',  this.fullData);
        const fullData = this.fullData;

        //const currentPage = page ? page : this.currentPage;
        //const trimStart = (currentPage - 1) * this.rowsPerPage;
        //const trimEnd = trimStart + this.rowsPerPage;
        //const fullData = this.fullData;
        //const filteredData = this.applyFilters(fullData);
        //const trimmedData = filteredData.slice(trimStart, trimEnd);

        this.seenData = fullData;
        this.maxPages = Math.ceil(this.maxRecords / this.rowsPerPage);

        //console.log('this.rowsPerPage', this.rowsPerPage, 'this.maxPages', this.maxPages, 'this.currentPage', this.currentPage, 'this.id', this.id, 'this.fullData', this.fullData, 'this.seenData', this.seenData, 'this.maxRecords', this.maxRecords, 'this.filter', this.filter);

        let html = '';
        for (let i in fullData) {
            if (!this.rowRendererOpts) {
                html += this.tableRowRenderer(fullData[i]);
            } else {
                html += this.tableRowRenderer(fullData[i], this.rowRendererOpts);
            }
        }
        //console.log('html', html);
        $(this.tableBody).html(html);

        if (this.OnTableRendered) {
            this.OnTableRendered();
        }
        this.renderNav(page);
    }

    renderNav(page = false) {
        const currentPage = page ? page : this.currentPage;
        const table = document.querySelector(this.table);
        if (!document.querySelector(this.table))
            return;
        const colCount =
            [].slice.call(
                table.querySelector('tr').cells
            )
                .reduce((a, b) => a + parseInt(b.colSpan), 0);

        const footerId = this.footerWithId ? `-${this.id}` : '';

        if (!document.querySelector(`.js-showing${footerId}`)) {
            table
                .createTFoot()
                .insertRow()
                .innerHTML = `
                <td class="js-showing${footerId}" colspan=${colCount}>
                    <span class="js-table-builder-pagination-text-${this.id}">Mostrando ${this.fullData.length} registros${this.maxPages == 1 || this.maxPages == 0 ? '' : ' por página'}. Total de ${this.maxRecords} registro${this.fullData.length > 1 ? 's' : ''}</span><br />
                    <nav class="js-table-builder-pagination-${this.id} mt-2"></nav>
                </td>`;
        } else {
            $(`.js-table-builder-pagination-text-${this.id}`).html(`Mostrando ${this.fullData.length} registro${this.fullData.length > 1 ? 's' : ''}${this.maxPages == 1 || this.maxPages == 0 ? '' : ' por página'}. Total de ${this.maxRecords} registros`);
        }

        //console.log('this.pages', this.maxPages, this.currentPage, this.id);

        if (this.maxPages == 1 || this.maxPages == 0)
            return $(`.js-table-builder-pagination-${this.id}`).html('');

        let pagesHtml = `

        <ul class="pagination flex flex-wrap items-center">
    
            <li class="page-item ${currentPage > 6 ? '' : 'd-none'}">
                <a class="page-link js-pagination-first-page-${this.id}" data-tippy-content="Ir para primeira página" href="#" rel="0">&laquo;&laquo;</a>
            </li>
    
            <li class="page-item ${currentPage > 1 ? '' : 'd-none'}">
                <span class="page-link js-pagination-previous-page-${this.id}" data-tippy-content="Página anterior">&laquo;</span>
            </li>`;

        let startPage = Math.max(1, currentPage - 5);
        let endPage = parseInt(startPage) + 9;

        if (endPage > this.maxPages) {
            endPage = this.maxPages;
            startPage = Math.max(1, endPage - 9);
        }

        if (startPage > 1) {
            /*for (let i = 1; i <= 5; i++) {
                pagesHtml += `<li class="page-item${i == currentPage ? ' active' : ''}"><a class="page-link test-class js-pagination-page-${this.id}" href="#" rel="${i - 1}">${i}</a></li>`;
            }*/
            if (startPage > 6) {
                pagesHtml += `<li class="page-item disabled"><span class="page-link">...</span></li>`;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pagesHtml += `<li class="page-item${i == currentPage ? ' active' : ''}"><a class="page-link testclass2 js-pagination-page-${this.id}" href="#" rel="${i - 1}">${i}</a></li>`;
        }

        if (endPage < this.maxPages) {
            if (endPage < this.maxPages - 5) {
                pagesHtml += `<li class="page-item disabled"><span class="page-link">...</span></li>`;
            }
            for (let i = this.maxPages - 4; i <= this.maxPages; i++) {
                pagesHtml += `<li class="page-item${i == currentPage ? ' active' : ''}"><a class="page-link testclass3 js-pagination-page-${this.id}" href="#" rel="${i - 1}">${i}</a></li>`;
            }
        }

        pagesHtml += `
    
            <li class="page-item  ${currentPage < this.maxPages - 1 ? '' : 'd-none'}">
                <a class="page-link js-pagination-next-page-${this.id}" href="#" data-tippy-content="Próxima página">&raquo;</a>
            </li>
    
            <li class="page-item ${currentPage < this.maxPages - 1 ? '' : 'd-none'}">
                <a class="page-link js-pagination-last-page-${this.id}" href="#" rel="${this.maxPages - 1}" data-tippy-content="Ir para última página">&raquo;&raquo;</a>
            </li>
    
        </ul>`;

        $(`.js-table-builder-pagination-${this.id}`).html(pagesHtml);
        //console.log('pagesHtml pagination',  `.js-table-builder-pagination-${this.id}`, pagesHtml);
    }

    applyFilters(data) {
        let mainData = data;
        //console.log('this.filter', this.filter);
        for (let i in this.filter) {
            let filterObj = this.filter[i];
            if (!filterObj.find || filterObj.find === '')
                continue;
            mainData = mainData.filter((value) => {
                return value?.[filterObj.name] === filterObj.find;
            });
        }

        return mainData;
    }

    bindFirstLastPage() {
        let self = this;
        $(document).on('click', `.js-pagination-first-page-${this.id}`, (e) => {
            e.preventDefault();
            if (self.OnClickFirstPage) {
                self.setCurrentPage(1);
                self.OnClickFirstPage();
            }
        });
        $(document).on('click', `.js-pagination-last-page-${this.id}`, (e) => {
            e.preventDefault();
            if (self.OnClickLastPage) {
                self.setCurrentPage(self.maxPages);
                self.OnClickLastPage();
            }
        });
    }

    setCurrentPage(age) {
        this.currentPage = age;
        this.renderNav(age);
        if (this.fetchTableData) {
            this.fetchTableData(this.currentPage);
        }
    }

    setCurrentFilter(newFilters) {
        this.filter = newFilters;
        this.currentPage = 1;
        this.renderNav(1);
        if (this.fetchTableData) {
            this.fetchTableData(this.currentPage);
        }
    }

    setFetchTableData(fetchTableData) {
        this.fetchTableData = fetchTableData;
    }

    setRowsPerPage(rowsPerPage) {
        this.rowsPerPage = rowsPerPage;
        this.currentPage = 1;
        this.renderNav(1);
        if (this.fetchTableData) {
            this.fetchTableData(this.currentPage);
        }
    }

    getCurrentPage() {
        return parseInt(this.currentPage);
    }

    getMaxPages() {
        return this.maxPages;
    }

    getTableId() {
        return this.id;
    }

    getCurrentFilters() {
        return this.filter;
    }
}
module.exports = TableBuilder;